import "./forget.scss";
import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Forget = () => {
  const [email, setEmail] = useState();
  const [message, setMessage] = useState();

  const axiosInstance = axios.create({baseURL: process.env.REACT_APP_API_URL, withCredentials: true})

  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmail((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post("/users/forget-password", email); 
      navigate("/");
    } catch (err) {
    console.log(err);
    setMessage("Upewnij się, że podałeś prawidłowy adres email.");
    }
  };

  return (
    <div className="reset">
      <div className="rContainer">
        <input
          type="email"
          placeholder="Adres email"
          id="email"
          onChange={handleChange}
          className="rInput"
        />
        <button onClick={handleClick} className="rButton">
          Wyślij formularz
        </button>
        {message && <span>{message}</span>}
        <div className="goBackLink">
          <Link
            to="/"
            style={{ textDecoration: "none", color: "#777" }}
          >
            <span>Wróć na stronę główną.</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Forget;
